export const DEFAULT_LOCALE = 'en' as const;

export const LOCALES = ['en', 'ru'] as const;

export type Locale = (typeof LOCALES)[number];

export const i18nConfig = {
  defaultLocale: DEFAULT_LOCALE,
  locales: LOCALES,
} as const;
